import React from 'react'
import { IncommOfferBanner } from './IncommOfferBanner'
import * as styles from './IncommOfferLayout.module.scss'
import classNames from 'util/mergeClasses'

interface IncommOfferLayoutProps {
  title: string
  description: string
  backgroundImageUrl: string
  children?: React.ReactNode | Element | React.ReactElement | null
  showBanner?: boolean
  backgroundColor?: string
  cardBackgroundColor?: string
  supportDescription?: string
  terms: string
  nextStepButton?: React.ReactNode
  skipButton?: React.ReactNode
  fullWidth?: boolean
}

export const IncommOfferLayout = ({
  children,
  title,
  description,
  backgroundImageUrl,
  showBanner = true,
  backgroundColor,
  cardBackgroundColor = '#F2EADA',
  supportDescription,
  terms,
  nextStepButton,
  skipButton,
  fullWidth = false,
}: IncommOfferLayoutProps) => {
  return (
    <div
      className={classNames(
        styles.stepContent,
        fullWidth && styles.stepContentFullWidth,
      )}
      style={{ backgroundColor }}
    >
      <div
        style={{ backgroundColor: cardBackgroundColor }}
        className={classNames(
          styles.incommOfferLayout,
          fullWidth && styles.incommOfferLayoutFullWidth,
        )}
      >
        <div
          className={classNames(
            styles.layoutInner,
            fullWidth && styles.layoutInnerConstrained,
          )}
        >
          {showBanner && (
            <div className={styles.bannerSection}>
              <IncommOfferBanner
                title={title}
                description={description}
                backgroundImageUrl={backgroundImageUrl}
              />
            </div>
          )}
          <div className={styles.contentSection}>
            {children as React.ReactNode}
          </div>
          <div className={styles.footerSection}>
            {supportDescription && (
              <span
                dangerouslySetInnerHTML={{ __html: supportDescription }}
                className={styles.supportSection}
              />
            )}
            <span
              dangerouslySetInnerHTML={{ __html: terms }}
              className={styles.termsSection}
            />
          </div>
        </div>
      </div>
      {nextStepButton}
      {skipButton}
    </div>
  )
}
